<template>
  <div class="wrapper">
    <div>
    <CButton   color="info" @click="openNew"><b>Add New Discover</b></CButton>
    <CButton class="ml-3"  color="info" @click="openOrder"><b>Set Content Position</b></CButton>
     <CRow class="mt-3">
      <CCol sm="12">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <Datatable 
                            :items="items" 
                            :fields="fields" 
                            :meta="meta" 
                            @per_page="handlePerPage" 
                            @pagination="handlePagination" 
                            @search="handleSearch" 
                            @sort="handleSort"
                            @is_active="handleIsActive"
                            :btn_show="false"
                            :btn_edit="true"
                            :btn_deactivate="true"
                            :btn_reactivate="true"
                            :btn_destroy="true"
                            @show="handleShow"
                            @edit="handleEdit"
                            @deactivate="handleDeactivate"
                            @reactivate="handleReactivate"
                            @destroy="handleDestroy"

                        />
                    </div>
                </div>
            </div>
        </div>
      </CCol>
    </CRow>
    <alertmodal></alertmodal>
    </div>
  </div>
</template>

<script>
import Datatable from '@/components/datatables_discover.vue'
import axios from 'axios'

import discover from '@/services/discover'
// import discovermodal from './discover_modal.vue';
// import discoverordermodal from './discover_order_modal.vue';
// import discoverdetailmodal from './discover_detail_modal.vue';

import alertmodal from '@/views/alert/modal.vue';
import EventBus from '@/eventBus';
import store from '@/store.js'
// import discover_detail_modal from './discover_detail_modal.vue';

const token = localStorage.getItem('token');

export default {
  name: 'discover',
  components: { alertmodal, Datatable},
  data(){
    return{
     
      updateSubmit: false,
      largeModal:false,
    
      //fungsi yang harus digunakan
      //start
      fields: [
          {key: 'title', sortable: false, },
          {key: 'author', sortable: false, },
          {key: 'is_active', sortable: false, },
          {key: 'action', label: 'Action', sortable: false},
      ],
      items: [],
      meta: [],
      current_page: 1,
      per_page: 10,
      search: '',
      sortBy: 'position',
      sortByDesc: false,
      is_active: 1,
      //end
    }
    //end
  },

  created() {
      //this.loadData()
  },
  mounted (){
     this.loadData()

    EventBus.$on('TABLE_UPDATE', (data) => {
      if(data){
          this.loadData();
      }
    });

   },
   
  methods: {
    openNew: function (){
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Create/edit discover') !== -1){
          //IF ALLOW
          this.$router.push({name:'Discover Form'})
          //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        } 
      }
      //SET END
    },
    openEdit(id){
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Create/edit discover') !== -1){
          //IF ALLOW
          this.$router.push({name:'Discover Form',query: {id:id} })
          //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        } 
      }
      //SET END
    },
    openOrder: function () {
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('View discover') !== -1){
          //IF ALLOW
          this.$router.push({name:'Discover Order'})
          //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        } 
      }
      //SET END
    },
    deactivate(id){
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Create/edit discover') !== -1){
          //IF ALLOW
      if(confirm("Do you really want to deactivate?")){
        discover.deactivateDiscover(id)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }  
       //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        } 
      }
      //SET END
    },

    reactivate(id){
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Create/edit discover') !== -1){
          //IF ALLOW
      if(confirm("Do you really want to reactivate?")){
        discover.reactivateDiscover(id)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }
       //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        } 
      }
      //SET END
    },

    destroy(id){
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Delete discover') !== -1){
          //IF ALLOW
      if(confirm("Do you really want to delete?")){
        discover.destroyDiscover(id)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }
       //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        } 
      }
      //SET END
    },

    loadData() {
      let current_page = this.search == '' ? this.current_page:1
      var params = {
       
        page: this.current_page,
        per_page: this.per_page,
        search: this.search,
        sortby: this.sortBy,
        sortbydesc: this.sortByDesc ? 'DESC':'ASC',
        is_active: this.is_active,
      }

      discover.getDiscoverDataSource(params)
      .then(res => {
          let getData = res.data
          this.items = getData.data
          //this.is_active = res.is_active
          this.meta = {
              total: getData.total,
              current_page: getData.current_page,
              per_page: getData.per_page,
              from: getData.from,
              to: getData.to,
              is_active: res.is_active
          }
          
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },

    handlePerPage(val) {
        this.per_page = val 
        this.loadData() 
    },
    
    handlePagination(val) {
        this.current_page = val 
        this.loadData()
    },
    
    handleSearch(val) {
        this.search = val 
        this.current_page = 1 
        this.loadData() 
    },
  
    handleSort(val) {
        this.sortBy = val.sortBy
        this.sortByDesc = val.sortDesc
        this.loadData()
    },
    
    handleIsActive(val) {
        this.is_active = val 
        this.loadData() 
    },

////HANDLE FUNCTION BUTTON ACTION////
    handleShow(val) {
        this.openShow(val) 
    }, 
    handleEdit(val) {
        this.openEdit(val) 
    },    
    handleDeactivate(val) {
        this.deactivate(val)       
    },
    handleReactivate(val) {
        this.reactivate(val)       
    },
    handleDestroy(val) {
        this.destroy(val)       
    },
  }
}
</script>
